export default "__VITE_ASSET__8Gs$pZMd__"